const UserListFilterer = (userList, searchString) => {
  if (searchString) {
    searchString = searchString.toUpperCase();
    userList = userList.filter(user =>
      user.userName.toUpperCase().includes(searchString) ||
        user.email.toUpperCase().includes(searchString) ||
        user.displayName.toUpperCase().includes(searchString));
  }

  return userList;
};

export default UserListFilterer;



// WEBPACK FOOTER //
// ./src/utils/filtering/UserListFilterer.js